export default {
  modalHeader: 'Link spare parts',
};
